import {useState} from "react";
import {getDeviceById} from "@/services/Device";

export default () => {
  const [deviceInfo, setDeviceInfo] = useState<Partial<DEVICE.Info>>({});
  const [loading, setLoading] = useState(false);

  const getDeviceInfo = async (id: string) => {
    setLoading(true);
    const res = await getDeviceById(id, {
      withTsl: true,
      withTypeAlias: true
    });
    setLoading(false);
    setDeviceInfo(res.data);
    return res;
  };

  return {
    deviceInfo,
    loading,
    getDeviceInfo
  }

}
